import { render, staticRenderFns } from "./PartnerPropertyPrimaryAttorneyYN.vue?vue&type=template&id=6d19ca62"
import script from "./PartnerPropertyPrimaryAttorneyYN.vue?vue&type=script&lang=js"
export * from "./PartnerPropertyPrimaryAttorneyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports